import React, { useEffect, useState } from "react";
import Table from "../../components/commonComponent/Table";
// import "../../styles/Therapist.css";
import Pagination from "../../components/commonComponent/Pagination";
import useModal from "../../hooks/useModal";
import {
  deleteData,
  fetchData,
  getCurrentData,
  handlePageChange,
} from "../../utils/utils";
import DeleteConfirmationModal from "../../components/commonComponent/DeleteConfirmationModal";
import ViewModal from "../../components/commonComponent/ViewModal";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Search from "../../components/commonComponent/Search";
import Filter from "../../components/commonComponent/Filter";

const API_URL = process.env.REACT_APP_API_URL;

const columns = [
  { header: "First Name", accessor: "firstName" },
  { header: "Last Name", accessor: "lastName" },
  { header: "State", accessor: "state" },
  { header: "City", accessor: "city" },
  { header: "Email", accessor: "email" },
];

const ITEMS_PER_PAGE = 10;

const Patient = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(true);

  const {
    showDeleteModal,
    showViewModal,
    selectedItem,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    handleOpenViewModal,
    handleCloseViewModal,
  } = useModal();
  const navigate = useNavigate();

  useEffect(() => {
    fetchData(
      `${API_URL}/getAllUsers`,
      setData,
      setError,
      setFilteredData,
      setLoading
    );
  }, []);

  const handleSearch = (searchTerm) => {
    const filtered = data.filter((patient) => {
      const firstName = patient.firstName || "";
      const lastName = patient.lastName || "";
      const email = patient.email || "";

      return (
        firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        email.toLowerCase().includes(searchTerm.toLowerCase())
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const handleFilterChange = (selectedFilters) => {
    setFilters(selectedFilters);

    const { State = [], City = [] } = selectedFilters;

    const filtered = data.filter((therapist) => {
      const stateMatch = State.length === 0 || State.includes(therapist.state);
      const cityMatch = City.length === 0 || City.includes(therapist.city);
      return stateMatch && cityMatch;
    });

    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const handleDeleteConfirm = () => {
    deleteData(`${API_URL}/deleteUserById`, selectedItem._id, setError)
      .then(() => {
        setData((prevData) =>
          prevData.filter((item) => item._id !== selectedItem._id)
        );
        setFilteredData((prevFilteredData) =>
          prevFilteredData.filter((item) => item._id !== selectedItem._id)
        ); // Update filtered data

        toast.success("Deleted successfully", { autoClose: 2000 });
      })
      .catch((error) => {
        setError(error);
        toast.error("Error deleting data", { autoClose: 2000 });
      });
    handleCloseDeleteModal();
  };

  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
  const currentData = getCurrentData(filteredData, currentPage, ITEMS_PER_PAGE);

  const fieldsToShow = {
    "First Name": "firstName",
    "Last Name": "lastName",
    Email: "email",
    State: "state",
    City: "city",
    "Profile Image": "profileImage",
    "Age Group": "ageGroup",
    "Relationship Status": "relationshipStatus",
    Sport: "sport",
    "Therapy Expectations": "therapyExpectations",
    "Therapy Reason": "therapyReasons",
  };

  const states = [...new Set(data.map((therapist) => therapist.state))];
  const cities = [...new Set(data.map((therapist) => therapist.city))];

  const filteredCities =
    filters.State && filters.State.length > 0
      ? [
          ...new Set(
            data
              .filter((therapist) => filters.State.includes(therapist.state))
              .map((therapist) => therapist.city)
          ),
        ]
      : cities;

  const filterOptions = {
    State: states,
    City: filteredCities,
  };

  return (
    <div className="therapist-page">
      <div className=" flex justify-between items-center text-[#1B1F2E] px-0 py-4 mb-2">
        <h2 className="text-[28px] font-semibold">Client List</h2>
        <Link
          to="/patient/add"
          className="font-normal text-white  py-2 px-4 rounded-md shadow hover:bg-gray-700 transition duration-200 bg-gray-800"
        >
          Add Client
        </Link>
      </div>
      <div className="search-filter-container shadow-sm  justify-between  gap-5 mb-3 flex-wrap bg-white rounded-lg px-3 py-3 flex items-start min-h-[170px] h-[170px]">
        <Search
          searchFields={["First Name", "Last Name", "Email"]}
          onSearch={handleSearch}
        />
        <Filter
          filterOptions={filterOptions}
          onFilterChange={handleFilterChange}
        />
      </div>
      <div className="table-container">
        <Table
          columns={columns}
          data={currentData}
          showIndex={true}
          loading={loading}
          currentPage={currentPage}
          itemsPerPage={ITEMS_PER_PAGE}
          onDelete={handleOpenDeleteModal}
          onUpdate={(item) => navigate(`/patient/edit/${item._id}`)}
          onView={handleOpenViewModal}
          onForm={(item) => navigate(`/patient/form/${item._id}`)}
          showEdit={true}
        />
        {!loading && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange(setCurrentPage)}
          />
        )}
      </div>
      <DeleteConfirmationModal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onConfirm={handleDeleteConfirm}
      />
      <ViewModal
        show={showViewModal}
        onHide={handleCloseViewModal}
        data={selectedItem}
        fields={fieldsToShow}
      />
    </div>
  );
};

export default Patient;
